<template>
	<div class="base-menu">
		<ul>
			<li ref="menu_items" v-for="(item, index) in menu" v-if="!item.hide" :key="index">
				<a :href="item.route" :disabled="item.disabled" :class="[itemClass]"
					v-if="item.isExternal && !item.action_name" target="_blank">
					<i v-if="item.icon_class" :class="item.icon_class">
						<span v-if="item.badge" class="badge">{{ item.badge }}</span>
					</i>
                    <component v-if="item.svg_icon" class="svg-icon" :is="item.svg_icon.name"
                    :width="item.svg_icon.width" :height="item.svg_icon.height" :color="item.svg_icon.color" :id="item.svg_icon.id" :has-sub="Boolean(item.sub_title)">
                        <span v-if="item.badge" class="badge">{{ item.badge }}</span>
                    </component>
					<span v-if="item.name" class="label">{{ item.name | translate }}</span>
				</a>
				<router-link :to="getBasicRoute(item)" :disabled="item.disabled" :class="[itemClass]"
					v-if="!item.isExternal && !item.action_name">
                    <i v-if="item.icon_class" :class="item.icon_class">
                        <span v-if="item.badge" class="badge">{{ item.badge }}</span>
                    </i>
                    <component v-if="item.svg_icon" class="svg-icon" :is="item.svg_icon.name"
                    :width="item.svg_icon.width" :height="item.svg_icon.height" :color="item.svg_icon.color" :id="item.svg_icon.id" :has-sub="Boolean(item.sub_title)">
                        <span v-if="item.badge" class="badge">{{ item.badge }}</span>
                    </component>
                    <span v-if="item.name" class="label">{{ item.name | translate }}</span>
                    <span v-if="item.sub_title"
                    :class="`sub_title ${item.sub_title ? item.sub_title.toString().toLowerCase() : ''} ${item.sub_title_class ? item.sub_title_class : ''}`">{{ item.sub_title | translate }}</span>
				</router-link>
				<a v-if="item.action_name" :href="item.href || '#'" :disabled="item.disabled" :class="[itemClass]"
					@click.prevent="handleAction(item.action_name, $event, item)">
					<i v-if="item.icon_class" :class="item.icon_class">
						<span v-if="item.badge" class="badge">{{ item.badge }}</span>
					</i>
                    <component v-if="item.svg_icon" class="svg-icon" :is="item.svg_icon.name"
                    :width="item.svg_icon.width" :height="item.svg_icon.height" :color="item.svg_icon.color" :id="item.svg_icon.id" :has-sub="Boolean(item.sub_title)">
                        <span v-if="item.badge" class="badge">{{ item.badge }}</span>
                    </component>
					<span v-if="item.name" class="label">{{ item.name | translate }}</span>
				</a>
			</li>
		</ul>
		<slot></slot>
  </div>
</template>

<script>
    import BaseMenu from '@views/common/BaseMenu/base_menu'
    import SvgHome from '@theme-views/common/SvgIcon/Icons/Home'
    import SvgSearch from '@theme-views/common/SvgIcon/Icons/Search'
    import SvgMessage from '@theme-views/common/SvgIcon/Icons/Message'
    import SvgChat from '@theme-views/common/SvgIcon/Icons/Chat'
    import SvgView from '@theme-views/common/SvgIcon/Icons/View'
    import SvgHeartFill from '@theme-views/common/SvgIcon/Icons/HeartFill'
    import SvgHeart from '@theme-views/common/SvgIcon/Icons/Heart'
    import SvgUnlock from '@theme-views/common/SvgIcon/Icons/Unlock'
    import SvgUser from '@theme-views/common/SvgIcon/Icons/User'
    import SvgStar from '@theme-views/common/SvgIcon/Icons/Star'
    import SvgTopup from '@theme-views/common/SvgIcon/Icons/Topup'
    import SvgGear from '@theme-views/common/SvgIcon/Icons/Gear'
    import SvgShutter from '@theme-views/common/SvgIcon/Icons/Shutter'
    import SvgCams from '@theme-views/common/SvgIcon/Icons/Cams'
    import {checkNull} from '@/helpers'

    export default {
        mixins: [BaseMenu],
        components: { 
            SvgHome, SvgSearch, SvgMessage, SvgChat, SvgView, SvgHeartFill,
            SvgHeart, SvgUnlock, SvgUser, SvgStar, SvgTopup, SvgGear, 
            SvgShutter, SvgCams 
        },
        data() {
            return {
                menu_hovered: [],
            }
        },
    }
</script>

<style lang="scss">
.base-menu {
	ul {
		padding: 0px;
		margin: 0px;
		li {
			a[disabled] {
				pointer-events: none;
				cursor: not-allowed;
				color: #B2B2B2;
			}
		}
	}
}
</style>
